import { Flex } from "antd";

const header_height = 40;

export default function useNavMenu() {
  const NavMenu = [
    {
      label: (
        <Flex
          align="center"
          justify="start"
          style={{ paddingInline: 8, height: header_height }}
        >
          Home
        </Flex>
      ),
      key: "Home",
    },
    {
      label: (
        <Flex
          align="center"
          justify="start"
          style={{ paddingInline: 8, height: header_height }}
        >
          Transaction
        </Flex>
      ),
      key: "Transaction",
    },
    {
      label: (
        <Flex
          align="center"
          justify="start"
          style={{ paddingInline: 8, height: header_height }}
        >
          Configuration
        </Flex>
      ),
      key: "Configuration",
      children: [{ label: "Food", key: "Food" }],
    },
  ];

  return [NavMenu, header_height];
}
